import React from "react";

const SuccessPage = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "80px" }}>
      <h2>✅ Patient Registered Successfully</h2>
      <p>Data saved in database</p>
    </div>
  );
};

export default SuccessPage;
